(function(){
 if(window.agibotOP3Details) return;
 window.agibotOP3Details=true;
 function init(){
  document.querySelectorAll('[data-op3-gallery]').forEach(gallery=>{
   if(gallery.dataset.ready) return;gallery.dataset.ready='true';
   const tabs=[...gallery.querySelectorAll('[role=tab]')];
   const panels=[...gallery.querySelectorAll('[role=tabpanel]')];
   function select(index,focus){tabs.forEach((t,i)=>{t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});if(focus)tabs[index].focus();}
   tabs.forEach((tab,i)=>{
    tab.addEventListener('click',()=>select(i,false));
    tab.addEventListener('keydown',event=>{
     let n=i;
     if(event.key==='ArrowRight')n=(i+1)%tabs.length;
     else if(event.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;
     else if(event.key==='Home')n=0;
     else if(event.key==='End')n=tabs.length-1;
     else return;
     event.preventDefault();select(n,true);
    });
   });
  });
 }
 document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
 document.addEventListener('shopify:section:load',init);
})();
